import { KeyRound } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { abrirDialogoDePin } from "@/lib/pin-link";

/** O PIN de ações sensíveis no Meu perfil: criar, ou redefinir com a senha da conta. */
export function PinDeSeguranca() {
  const status = trpc.pin.status.useQuery();
  const temPin = !!status.data?.temPin;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex items-start gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-50 text-brand-700 dark:bg-primary/10 dark:text-primary">
          <KeyRound className="h-4 w-4" />
        </span>
        <div>
          <p className="text-sm font-semibold text-zinc-900 dark:text-foreground">PIN de segurança</p>
          <p className="text-[12.5px] text-zinc-500 dark:text-muted-foreground">
            {temPin
              ? "Pedido ao mudar preços, transferir a organização ou dar o papel de Sócio."
              : "Você ainda não criou um PIN. Ele protege mudanças de preço e a transferência da organização."}
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={() => abrirDialogoDePin(temPin ? "redefinir" : "criar")}
        className="inline-flex h-9 items-center rounded-md border border-zinc-200 bg-white px-3 text-[13px] font-semibold text-zinc-800 hover:bg-zinc-50 dark:border-border dark:bg-card dark:text-foreground dark:hover:bg-muted"
      >
        {temPin ? "Redefinir PIN" : "Criar PIN"}
      </button>
    </div>
  );
}
